import { BaseStrings } from "./base_strings";

export const Strings: BaseStrings = {
    appLongName: "Zero Touch PKI",
    appShortName: "Zero Touch PKI",
    brandName: "CyberArk",
    rootCssClass: "ztp",
    supportEmail: "mis.support@cyberark.com",
    helpDocuments: {
        html: {
            url: "https://docs.cyberark.com/mis-saas/ztpki/overview-ztpki/",
            label: "View Zero Touch PKI Overview",
        },
    },
    chartColors: [
        {
            backgroundColor: "#087d25",
            borderColor: "#05651c",
            pointBackgroundColor: "#14c345",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "#0bae2e",
        },
    ],
};
